import React from 'react';
import {Field} from 'redux-form'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import MenuItem from 'material-ui/MenuItem';

import IconButton from 'material-ui/IconButton';

import FormAutoComplete2 from './FormAutoComplete2'
import FormSelect from './FormSelect'
import FormText from './FormText'
import FormDatePicker from './FormDatePicker'

import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons';

const moment = require('moment');

const style = {
  margin: 0,
  top: 'auto',
  right: 20,
  bottom: 20,
  left: 'auto',
  position: 'fixed',
};

class FormUserPriceContents extends React.Component {


  clearDate = (index, fields, fieldName) => {
    if (window.confirm("日付をクリアします。よろしいですか？")) {
      let field = fields.get(index)
      field[fieldName] = "";
      fields.insert(field)
    }
  }

  render() {

    const {
      fields,
      dialogMonth,
      priceData,
    } = this.props

    return (
      <div style={{marginBottom: 20}}>

        <div className="row">

          {fields.map((name, index) => {

            return (
              <div className="col-12" key={index}>
                <div className="row">

                  <div className="col-5">

                    <Field
                        name={`${name}.priceId`}
                        component={FormSelect}
                        style={{width: '100%'}}
                        label="時間単価"
                    >
                      {
                        priceData && priceData.map((x, index) => {
                          return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                        })
                      }
                    </Field>

                  </div>

                  <div className="col-7">
                    <Field
                      key={index}
                      name={`${name}.startDate`}
                      component={FormDatePicker}
                      label="適用日" style={{width: '100%'}}
                      textFieldStyle={{width: '100%'}}
                      dialogMonth={dialogMonth}
                      inputStyle={{color: colors.grey800}}
                      floatingLabelStyle={{color: colors.grey500}}
                      onDismiss={this.clearDate.bind(this, index, fields, 'date')}
                    />
                  </div>

                </div>
              </div>
            )

          })}

        </div>


        <div className="row">

          <div className="col-12" style={{display: 'flex', justifyContent: 'flex-end', marginTop: 15}}>
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400}
                                  onClick={() => {
                                    fields.push({})
                                  }}>
              <ContentAdd/>
            </FloatingActionButton>
          </div>
        </div>


      </div>

    )

  }

}

export default FormUserPriceContents


// WEBPACK FOOTER //
// ./src/components/FormUserPriceContents.js